// src/components/layout/Footer.js
//
// Footer público de EducaT — identidad FENAGRO APL real (theme, logo,
// tipografía Playfair Display + Outfit), igual que en fenagro_front.
// Se muestra solo en el Landing (Home.js envuelve con fenagroTheme).

import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Grid, Typography, Divider } from '@mui/material';
import fenagroLogo from '../../assets/fenagro-logo.png';

function Footer() {
  return (
    <Box sx={{ bgcolor: '#1a3a1e', color: 'rgba(255,255,255,0.85)', pt: 6, pb: 3 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
              <Box component="img" src={fenagroLogo} alt="FENAGRO APL" sx={{ height: 48 }} />
              <Box>
                <Typography sx={{ fontWeight: 700, fontSize: '1rem', color: '#fff' }}>FENAGRO</Typography>
                <Typography sx={{ fontSize: '0.65rem', letterSpacing: '0.1em', color: 'rgba(255,255,255,0.6)' }}>
                  APL · RED AGROINDUSTRIAL
                </Typography>
              </Box>
            </Box>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.65)', maxWidth: 320 }}>
              El Aula Virtual de la Confederación Alianza Solidaria y la Federación FENAGRO APL —
              economías colaborativas al servicio de la educación.
            </Typography>
          </Grid>

          <Grid item xs={6} md={4}>
            <Typography sx={{ fontWeight: 700, mb: 2, fontSize: '0.75rem', letterSpacing: '0.08em', color: '#fff' }}>
              PLATAFORMA
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link to="/login" style={{ color: 'inherit', textDecoration: 'none', opacity: 0.75, fontSize: '0.85rem' }}>
                Iniciar sesión
              </Link>
              <Link to="/instituciones/inscripcion" style={{ color: 'inherit', textDecoration: 'none', opacity: 0.75, fontSize: '0.85rem' }}>
                Mi institución quiere unirse
              </Link>
            </Box>
          </Grid>

          <Grid item xs={6} md={4}>
            <Typography sx={{ fontWeight: 700, mb: 2, fontSize: '0.75rem', letterSpacing: '0.08em', color: '#fff' }}>
              CONTACTO
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.65)', mb: 0.5 }}>
              fenagro@gmail.com
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.65)' }}>
              fenagroapl.com.co
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.12)' }} />

        <Typography variant="body2" sx={{ textAlign: 'center', color: 'rgba(255,255,255,0.5)', fontSize: '0.8rem' }}>
          © {new Date().getFullYear()} FENAGRO APL — Todos los derechos reservados
        </Typography>
      </Container>
    </Box>
  );
}

export default Footer;

